import { useContext, useState, useEffect } from 'react';
import FiltersDisplayUI from './FiltersDisplayUI';
import { SegmentationFiltersInstanceProvider } from '../../state/SegmentationFiltersInstanceContext';
import SegmentationFiltersSharedContext, { SegmentationFiltersSharedProvider } from '../../state/SegmentationFiltersSharedContext';
import emptyFunction from 'react-utils/emptyFunction';
import enviro from 'enviro';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const FiltersDisplay = props => {
  const {
    baseFilterFamily,
    value,
    strategy,
    onChange,
    uiMessages
  } = props;
  const sharedContext = useContext(SegmentationFiltersSharedContext);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    setVersion(version + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  if (strategy && Object.keys(sharedContext).length > 0) {
    const errorMessage = 'Detected usage of `SegmentationFiltersSharedProvider`. Did you mean you to also pass the `strategy` prop? to `FiltersDisplay`?';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage]
      });
    }
  }
  const filtersDisplayInstance = /*#__PURE__*/_jsx(SegmentationFiltersInstanceProvider, {
    baseFilterFamily: baseFilterFamily,
    value: value,
    onChange: onChange || emptyFunction,
    uiMessages: uiMessages,
    children: /*#__PURE__*/_jsx(FiltersDisplayUI, {})
  }, version);
  if (strategy) {
    return /*#__PURE__*/_jsx(SegmentationFiltersSharedProvider, {
      strategy: strategy,
      children: filtersDisplayInstance
    });
  }
  const hasStrategyFromSharedContext = sharedContext.props && sharedContext.props.strategy;
  if (!hasStrategyFromSharedContext) {
    const errorMessage = 'No detected usage of `SegmentationFiltersSharedProvider` and missing `strategy` prop. Please pass in a `strategy` prop to `FiltersDisplay` or wrap with `SegmentationFiltersSharedProvider`.';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage]
      });
    }
  }
  return filtersDisplayInstance;
};
export default FiltersDisplay;